import React , {Component} from 'react';
import HeaderViews from '../views/Header';

class Header extends Component {

    

    render() {
        return (
            <HeaderViews/>
        );
    }
}

export default Header;
